import { render, staticRenderFns } from "./NotesTask.vue?vue&type=template&id=caca4436"
import script from "./NotesTask.vue?vue&type=script&lang=js"
export * from "./NotesTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports